export class PsgcCityModel {
    constructor(payload) {
        const { name, cityMunicipalityCode } = payload;
        this.name = name;
        this.cityMunicipalityCode = cityMunicipalityCode;
    }
    get formattedCityName() {
        const lastIndex = this.name.lastIndexOf(' ');
        return this.name.substring(0, lastIndex);
    }
}
